import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { CONTACT } from "@/constants/testIds";
import { BUSINESS } from "@/data/siteData";

export default function Contact() {
  return (
    <section id="contact" data-testid={CONTACT.root} className="pe-section bg-[var(--pe-ink)]">
      <div className="container-pe">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-6">
            <div className="pe-eyebrow mb-5">Contact</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1]">
              READY WHEN
              <br />
              <span className="text-[var(--pe-gold)]">YOU ARE.</span>
            </h2>
            <p className="mt-6 text-[var(--pe-muted)] max-w-lg leading-relaxed">
              The quickest way to reach us is a phone call. For non-urgent
              jobs, email works just as well — we usually reply same day.
            </p>
          </div>

          <div className="lg:col-span-6 grid sm:grid-cols-2 gap-4">
            <a
              href={BUSINESS.phoneHref}
              data-testid={CONTACT.call}
              className="pe-card group"
            >
              <Phone className="h-6 w-6 text-[var(--pe-gold)]" />
              <div className="mt-5 font-mono text-[10px] tracking-[0.24em] uppercase text-[var(--pe-muted)]">
                Call
              </div>
              <div className="mt-1 font-display text-2xl text-white tracking-wide group-hover:text-[var(--pe-gold)] transition-colors">
                {BUSINESS.phone}
              </div>
              <div className="mt-2 text-xs text-[var(--pe-muted)]">Tap to call from mobile</div>
            </a>

            <a
              href={BUSINESS.emailHref}
              data-testid={CONTACT.email}
              className="pe-card group"
            >
              <Mail className="h-6 w-6 text-[var(--pe-gold)]" />
              <div className="mt-5 font-mono text-[10px] tracking-[0.24em] uppercase text-[var(--pe-muted)]">
                Email
              </div>
              <div className="mt-1 font-display text-lg md:text-xl text-white tracking-wide break-all group-hover:text-[var(--pe-gold)] transition-colors">
                {BUSINESS.email}
              </div>
              <div className="mt-2 text-xs text-[var(--pe-muted)]">Quotes, questions, scheduling</div>
            </a>

            <div className="pe-card">
              <MapPin className="h-6 w-6 text-[var(--pe-blue)]" />
              <div className="mt-5 font-mono text-[10px] tracking-[0.24em] uppercase text-[var(--pe-muted)]">
                Service Area
              </div>
              <div className="mt-1 font-display text-xl text-white tracking-wide">
                Manitoba & Surrounding Areas
              </div>
              <div className="mt-2 text-xs text-[var(--pe-muted)]">
                Call to confirm coverage for your job site.
              </div>
            </div>

            <div className="pe-card">
              <Clock className="h-6 w-6 text-[var(--pe-blue)]" />
              <div className="mt-5 font-mono text-[10px] tracking-[0.24em] uppercase text-[var(--pe-muted)]">
                Availability
              </div>
              <div className="mt-1 font-display text-xl text-white tracking-wide">
                Reach Us Anytime
              </div>
              <div className="mt-2 text-xs text-[var(--pe-muted)]">
                Calls, texts and emails answered days, evenings and weekends — best effort on after-hours emergencies.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
